import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"
import _imports_0 from '../../public/assets/icon/icon_left.png'


const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "login-logo" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "Ionic logo"
  })
], -1)
const _hoisted_2 = { class: "password_row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_SelectBoxString = _resolveComponent("SelectBoxString")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_list = _resolveComponent("ion-list")!
  const _component_ion_content = _resolveComponent("ion-content")!
  const _component_ion_page = _resolveComponent("ion-page")!

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withCtx(() => [
      _createVNode(_component_ion_content, null, {
        default: _withCtx(() => [
          _hoisted_1,
          _createVNode(_component_ion_list, null, {
            default: _withCtx(() => [
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    position: "stacked",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Usuario")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_input, {
                    autofocus: "",
                    modelValue: _ctx.authStore.username,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.authStore.username) = $event)),
                    onIonBlur: _ctx.cargaFarmacias
                  }, null, 8, ["modelValue", "onIonBlur"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    position: "stacked",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Contraseña")
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_2, [
                    _createVNode(_component_ion_input, {
                      modelValue: _ctx.password,
                      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.password) = $event)),
                      type: _ctx.typePassword
                    }, null, 8, ["modelValue", "type"]),
                    _createElementVNode("a", {
                      class: "type-toggle",
                      onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.toggleShow()))
                    }, [
                      _withDirectives(_createVNode(_component_ion_icon, {
                        class: "show-option",
                        icon: _ctx.eyeOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, _ctx.showPassword]
                      ]),
                      _withDirectives(_createVNode(_component_ion_icon, {
                        class: "hide-option",
                        icon: _ctx.eyeOffOutline
                      }, null, 8, ["icon"]), [
                        [_vShow, !_ctx.showPassword]
                      ])
                    ])
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_label, {
                    position: "stacked",
                    color: "primary"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Farmacia")
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_SelectBoxString, {
                    options: _ctx.farmacias,
                    text: "FarmaciaDescripcion",
                    id: "FarmaciaCodigo",
                    modelValue: _ctx.farmaciaSelected,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.farmaciaSelected) = $event))
                  }, null, 8, ["options", "modelValue"])
                ]),
                _: 1
              }),
              _createVNode(_component_ion_item, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_button, {
                    size: "default",
                    class: "login-button",
                    onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.login()))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Entrar")
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}